import React from 'react';
import type { ProratedRentErrors, TenantStatus } from './types';

import { format } from 'date-fns';

// Constellation
import {
  AdornedInput,
  Button,
  DateInput,
  DatePicker,
  FormActions,
  FormField,
  FormHelp,
  Label,
  Select,
  Text,
  Form as ZCForm,
} from '@zillow/constellation-10';

interface FormProps {
  tenantStatuses: Array<TenantStatus>;
  setTenantStatus: (status: TenantStatus) => void;
  setMonthlyRent: (rent: string) => void;
  setMoveDate: (value: string) => void;
  handleCalculateButtonClick: () => void;
  errors: ProratedRentErrors;
}

const Form: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<FormProps>>> = ({
  tenantStatuses,
  setTenantStatus,
  setMonthlyRent,
  setMoveDate,
  handleCalculateButtonClick,
  errors,
}: FormProps) => {
  const handleChangeTenantStatus = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setTenantStatus(e.target.value as TenantStatus);
  const handleChangeMoveDate = (value: string | Date) => {
    const formatted = typeof value === 'string' ? value : format(value, 'MM/dd/yyyy');
    setMoveDate(formatted);
  };
  const handleChangeRent = (e: React.ChangeEvent<HTMLInputElement>) => setMonthlyRent(e.target.value);
  return (
    <ZCForm>
      <FormField
        label={<Label>Select tenant status</Label>}
        control={
          <Select onChange={handleChangeTenantStatus}>
            {tenantStatuses.map((status: TenantStatus) => (
              <option key={status}>{status}</option>
            ))}
          </Select>
        }
      />
      <FormField
        label={<Label>Enter monthly rent</Label>}
        control={
          <AdornedInput
            input={<AdornedInput.Input placeholder="Enter monthly rent amount" onChange={handleChangeRent} />}
            startAdornment={
              <AdornedInput.Adornment>
                <Text>$</Text>
              </AdornedInput.Adornment>
            }
          />
        }
        error={!!errors.monthlyRent}
        description={errors.monthlyRent && <FormHelp>{errors.monthlyRent}</FormHelp>}
      />
      <FormField
        label={<Label>Enter tenant move date</Label>}
        control={
          <DatePicker
            onValueChange={handleChangeMoveDate}
            input={<DateInput placeholder="Select date" css={{ _placeholder: { textTransform: 'none' } }} />}
          />
        }
        error={!!errors.moveDate}
        description={errors.moveDate && <FormHelp>{errors.moveDate}</FormHelp>}
      />
      <FormActions css={{ textAlign: 'center', marginTop: '400' }}>
        <Button
          tone="brand"
          emphasis="filled"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            handleCalculateButtonClick();
          }}
          fluid
        >
          Calculate
        </Button>
      </FormActions>
    </ZCForm>
  );
};

export default Form;
